import { computed, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import * as fromAuth from 'src/app/modules/authentication/store/auth';
import { take } from 'rxjs/operators';
import { UserContext } from 'src/app/modules/authentication/store/auth/user-context.model';
import { Permissions } from '@app/modules/authentication/store/auth/permissions';

@Injectable({ providedIn: 'root' })
export class UserContextService {
  constructor(private authStore: Store<fromAuth.State>) {}

  readonly getContext = this.authStore.selectSignal(fromAuth.selectUserContext);

  getUserContext(): UserContext {
    let userContext: UserContext = null;

    this.authStore
      .select(fromAuth.selectUserContext)
      .pipe(take(1))
      .subscribe(value => {
        userContext = value;
      });

    return userContext;
  }

  // *********************
  // ***  Permissions  ***
  // *********************
  // TODO: add rest of Permissions as needed.

  // -- Channels --
  readonly canCreateChannels = computed(() => this.getContext()?.hasPermission(Permissions.ChannelConfigCreate));
  readonly canReadChannels = computed(() => this.getContext()?.hasPermission(Permissions.ChannelConfigRead));
  readonly canUpdateChannels = computed(() => this.getContext()?.hasPermission(Permissions.ChannelConfigUpdate));
  readonly canDeleteChannels = computed(() => this.getContext()?.hasPermission(Permissions.ChannelConfigDelete));

  // -- Communication Notification --
  readonly canCreateCommunicationNotification = computed(() => this.getContext()?.hasPermission(Permissions.CommunicationNotificationCreate));
  readonly canReadCommunicationNotification = computed(() => this.getContext()?.hasPermission(Permissions.CommunicationNotificationRead));
  readonly canUpdateCommunicationNotification = computed(() => this.getContext()?.hasPermission(Permissions.CommunicationNotificationUpdate));
  readonly canDeleteCommunicationNotification = computed(() => this.getContext()?.hasPermission(Permissions.CommunicationNotificationDelete));

  // -- Communication Template --
  readonly canCreateCommunicationTemplate = computed(() => this.getContext()?.hasPermission(Permissions.CommunicationTemplateCreate));
  readonly canReadCommunicationTemplate = computed(() => this.getContext()?.hasPermission(Permissions.CommunicationTemplateRead));
  readonly canUpdateCommunicationTemplate = computed(() => this.getContext()?.hasPermission(Permissions.CommunicationTemplateUpdate));
  readonly canDeleteCommunicationTemplate = computed(() => this.getContext()?.hasPermission(Permissions.CommunicationTemplateDelete));

  // -- Distribution List --
  readonly canCreateDistributionList = computed(() => this.getContext()?.hasPermission(Permissions.DistributionListCreate));
  readonly canReadDistributionList = computed(() => this.getContext()?.hasPermission(Permissions.DistributionListRead));
  readonly canUpdateDistributionList = computed(() => this.getContext()?.hasPermission(Permissions.DistributionListUpdate));
  readonly canDeleteDistributionList = computed(() => this.getContext()?.hasPermission(Permissions.DistributionListDelete));

  // -- Workflow --
  readonly canCreateWorkflow = computed(() => this.getContext()?.hasPermission(Permissions.WorkflowCreate));
  readonly canReadWorkflow = computed(() => this.getContext()?.hasPermission(Permissions.WorkflowRead));
  readonly canUpdateWorkflow = computed(() => this.getContext()?.hasPermission(Permissions.WorkflowUpdate));
  readonly canDeleteWorkflow = computed(() => this.getContext()?.hasPermission(Permissions.WorkflowDelete));
}
